// Configuración del onboarding guiado de CaptAcción.
// Reutilizado también en «Mi negocio» para editar las respuestas.

export const EXPERIENCE_OPTIONS = [
  { k: "principiante", label: "Empiezo desde cero", hint: "Aún no tienes perfiles activos o casi no los usas para tu negocio. CaptAcción te ayudará a preparar tus perfiles antes de contactar." },
  { k: "con_perfiles", label: "Tengo mis perfiles creados, pero casi no prospecto", hint: "Estás en redes pero no buscas oportunidades de forma constante." },
  { k: "avanzado", label: "Ya prospecto y quiero organizarme o mejorar resultados", hint: "Buscas orden, método y mejores resultados." },
];

export const BUSINESS_TYPES = [
  { k: "servicios", label: "Profesional de servicios, consultor, mentor, coach o freelance" },
  { k: "agencia", label: "Agencia o empresa de servicios" },
  { k: "productos", label: "Negocio que vende productos" },
  { k: "local", label: "Negocio local" },
  { k: "network", label: "Network marketing o venta directa" },
  { k: "distribuidor", label: "Distribuidor o representante comercial" },
  { k: "afiliado", label: "Afiliado, creador o recomendador" },
  { k: "formador", label: "Formador, academia o negocio educativo" },
  { k: "otro", label: "Otro" },
];

export const businessTypeLabel = (k) => BUSINESS_TYPES.find((t) => t.k === k)?.label || "Sin definir";

export const NETWORK_OPTIONS = [
  { k: "instagram", label: "Instagram" },
  { k: "facebook", label: "Facebook" },
  { k: "linkedin", label: "LinkedIn" },
];

export const COMM_OPTIONS = [
  { k: "texto", label: "Texto" },
  { k: "audio", label: "Audio" },
  { k: "llamada", label: "Llamada" },
  { k: "combinacion", label: "Combinación" },
];

// Preguntas específicas por tipo de negocio. type: input | textarea | select
const SERVICIOS_Q = [
  { k: "services_offered", label: "¿Qué servicios ofreces?", type: "textarea", required: true, hint: "Ej.: consultoría de marca, mentoría de ventas…" },
  { k: "result_helped", label: "¿Qué resultado ayudas a conseguir?", type: "textarea" },
  { k: "who_help", label: "¿A qué tipo de personas o empresas ayudas?", type: "input" },
  { k: "problems_solved", label: "¿Qué problemas resuelves?", type: "textarea" },
  { k: "prices", label: "Precios o rango de precios", type: "input", hint: "Opcional. Ej.: desde 300€/mes." },
  { k: "duration_format", label: "Duración y forma de prestación", type: "input", hint: "Opcional. Ej.: sesiones online de 60 min." },
  { k: "cases", label: "Casos, testimonios o experiencia", type: "textarea" },
  { k: "capacity", label: "Capacidad disponible para nuevos clientes", type: "input", hint: "Opcional. Ej.: 3 clientes al mes." },
];

const AGENCIA_EXTRA = [
  { k: "main_complementary", label: "Servicios principales y complementarios", type: "textarea" },
  { k: "who_sells", label: "¿Quién realiza la venta?", type: "input" },
  { k: "who_delivers", label: "¿Quién presta el servicio?", type: "input" },
  { k: "sectors", label: "¿Qué sectores atendéis?", type: "input" },
  { k: "new_clients_capacity", label: "Nº de nuevos clientes que podéis asumir", type: "input" },
  { k: "partners", label: "Posibles colaboradores o socios complementarios", type: "textarea" },
];

export const TYPE_QUESTIONS = {
  servicios: SERVICIOS_Q,
  agencia: [...SERVICIOS_Q, ...AGENCIA_EXTRA],
  productos: [
    { k: "products", label: "¿Qué productos vendes?", type: "textarea", required: true },
    { k: "categories_priority", label: "Categorías y productos prioritarios", type: "input" },
    { k: "avg_price", label: "Precio medio", type: "input", hint: "Opcional." },
    { k: "channel_sale", label: "¿Dónde vendes?", type: "select", options: [
      { k: "online", label: "Online" }, { k: "fisica", label: "Física" }, { k: "ambas", label: "Ambas" },
    ] },
    { k: "client_type", label: "¿Vendes a cliente final o a empresa?", type: "select", options: [
      { k: "cliente_final", label: "Cliente final" }, { k: "empresa", label: "Empresa" }, { k: "ambos", label: "Ambos" },
    ] },
    { k: "delivery_area", label: "Zona de entrega o distribución", type: "input" },
    { k: "differentiators", label: "Diferencias frente a alternativas", type: "textarea" },
    { k: "looking_for", label: "¿Buscas clientes, distribuidores, puntos de venta, afiliados o recomendadores?", type: "input" },
  ],
  local: [
    { k: "establishment_type", label: "Tipo de establecimiento", type: "input", required: true, hint: "Ej.: restaurante, peluquería, clínica…" },
    { k: "address_area", label: "Dirección o zona atendida", type: "input" },
    { k: "main_products", label: "Servicios o productos principales", type: "textarea" },
    { k: "radius", label: "Radio geográfico", type: "input", hint: "Opcional. Ej.: 10 km." },
    { k: "hours", label: "Horarios", type: "input" },
    { k: "main_conversion", label: "Conversión principal", type: "select", options: [
      { k: "reserva", label: "Reserva" }, { k: "visita", label: "Visita" }, { k: "llamada", label: "Llamada" }, { k: "compra", label: "Compra" },
    ] },
    { k: "local_partners", label: "Tipos de negocios locales con los que podrías colaborar", type: "input" },
  ],
  network: [
    { k: "company", label: "Compañía o proyecto", type: "input", required: true },
    { k: "products", label: "Productos o servicios que representas", type: "textarea" },
    { k: "buyer_audience", label: "Público comprador", type: "input" },
    { k: "looking_for", label: "¿Qué buscas?", type: "select", options: [
      { k: "clientes", label: "Clientes" }, { k: "socios", label: "Socios de negocio" }, { k: "ambos", label: "Ambos" },
    ] },
    { k: "partner_profile", label: "Perfil de socio que encaja", type: "textarea" },
    { k: "experience", label: "Tu experiencia y resultados", type: "textarea", hint: "Sin exigir promesas económicas." },
    { k: "markets", label: "Mercados o países permitidos", type: "input" },
    { k: "comm_restrictions", label: "Restricciones de comunicación de la compañía", type: "textarea" },
    { k: "support", label: "Tipo de acompañamiento que ofreces a nuevos socios", type: "textarea" },
  ],
  distribuidor: [
    { k: "brands", label: "Productos o marcas que representas", type: "textarea", required: true },
    { k: "territory", label: "Zona o exclusividad territorial", type: "input" },
    { k: "client_type", label: "Cliente final, comercio, profesional o empresa", type: "input" },
    { k: "order_volume", label: "Volumen o tipo de pedido habitual", type: "input" },
    { k: "looking_for", label: "¿Buscas compradores, distribuidores secundarios, comercios o alianzas?", type: "input" },
  ],
  afiliado: [
    { k: "niche", label: "Temática o nicho", type: "input", required: true },
    { k: "audience", label: "Audiencia actual", type: "input", hint: "Opcional. Ej.: 5.000 seguidores en Instagram." },
    { k: "products_recommended", label: "Productos o servicios que recomiendas", type: "textarea" },
    { k: "content_channels", label: "Canales de contenido", type: "input" },
    { k: "looking_for", label: "¿Buscas audiencia cualificada, marcas, colaboradores, afiliados o recomendadores?", type: "input" },
    { k: "collab_model", label: "Condiciones o modelo de colaboración", type: "textarea" },
  ],
  formador: [
    { k: "training", label: "Formación que ofreces", type: "textarea", required: true },
    { k: "modality", label: "Modalidad", type: "select", options: [
      { k: "presencial", label: "Presencial" }, { k: "online", label: "Online" }, { k: "hibrida", label: "Híbrida" },
    ] },
    { k: "student_profile", label: "Perfil del alumno", type: "input" },
    { k: "learning_result", label: "Resultado de aprendizaje", type: "textarea" },
    { k: "price_duration", label: "Precio y duración", type: "input" },
    { k: "dates", label: "Fechas o disponibilidad", type: "input" },
    { k: "looking_for", label: "¿Buscas alumnos, empresas, colaboradores o prescriptores?", type: "input" },
  ],
  otro: [
    { k: "how_works", label: "¿Cómo funciona tu actividad?", type: "textarea", required: true },
    { k: "what_sells", label: "¿Qué vendes u ofreces?", type: "textarea" },
    { k: "who_find", label: "¿A quién quieres encontrar?", type: "input" },
    { k: "success_def", label: "¿Qué debe ocurrir para considerar que una oportunidad ha tenido éxito?", type: "textarea" },
  ],
};

export const GOAL_OPTIONS = [
  { k: "clientes_producto", label: "Conseguir clientes para un producto concreto" },
  { k: "clientes_servicio", label: "Conseguir clientes para un servicio concreto" },
  { k: "socios_distribuidores", label: "Encontrar socios o distribuidores" },
  { k: "afiliados_colaboradores", label: "Encontrar afiliados o colaboradores" },
  { k: "networking", label: "Hacer networking y crear alianzas" },
  { k: "seguidores", label: "Conseguir seguidores exclusivamente cualificados" },
  { k: "promotores", label: "Encontrar promotores o recomendadores" },
  { k: "referidos", label: "Conseguir referidos" },
  { k: "reactivar", label: "Reactivar contactos existentes" },
];

export const goalLabel = (k) => GOAL_OPTIONS.find((g) => g.k === k)?.label || k;

export const TOTAL_ONB_STEPS = 6;

// Textos visibles del onboarding (mockup aprobado). Las claves internas no cambian.
export const EXPERIENCE_ONB = {
  principiante: ["Estoy empezando", "Aún no he contactado prospectos o estoy aprendiendo."],
  con_perfiles: ["Ya lo he probado algunas veces", "He hecho algunos contactos y quiero mejorar."],
  avanzado: ["Lo hago con frecuencia", "Ya tengo un método y busco más control."],
};

export const TYPE_ONB = {
  servicios: ["Profesional de servicios", "Consultoría, mentoría o actividad independiente"],
  agencia: ["Agencia o empresa de servicios", "Un equipo presta servicios a clientes"],
  productos: ["Negocio de productos", "Vendes productos físicos o digitales"],
  local: ["Negocio local", "Atiendes en una ubicación o zona"],
  network: ["Network marketing o venta directa", "Venta directa, clientes y/o socios"],
  distribuidor: ["Distribuidor o representante comercial", "Representas marcas o productos"],
  afiliado: ["Afiliado, creador o recomendador", "Creas contenido o recomiendas ofertas"],
  formador: ["Formador, academia o negocio educativo", "Cursos, programas o formación"],
  otro: ["Otro", "Describe tu modelo con tus palabras"],
};

export const GOAL_ONB = {
  clientes_producto: ["Conseguir clientes para un producto", "Encontrar personas o empresas que podrían comprarlo."],
  clientes_servicio: ["Conseguir clientes para un servicio", "Encontrar personas o empresas que podrían necesitarlo."],
  socios_distribuidores: ["Encontrar socios o distribuidores", "Personas que podrían desarrollar o representar el negocio."],
  afiliados_colaboradores: ["Encontrar afiliados o colaboradores", "Personas que promocionen la oferta o aporten servicios complementarios."],
  networking: ["Crear alianzas profesionales", "Negocios o profesionales con quienes plantear proyectos o acuerdos conjuntos."],
  seguidores: ["Ampliar audiencia con seguidores cualificados", "Personas interesadas en los temas relacionados con tu actividad."],
  promotores: ["Encontrar promotores o recomendadores", "Personas que podrían compartir o recomendar tu oferta."],
  reactivar: ["Retomar contactos que ya conoces", "Reactiva conversaciones y oportunidades con personas que ya están en tu red."],
};

export const ACQ_OPTIONS = ["Recomendaciones", "Redes sociales", "Contenido", "Prospección directa", "Publicidad", "Eventos / networking", "Red personal", "Todavía ninguna"];

export const ONB_NETWORKS = [
  { k: "instagram", label: "Instagram" }, { k: "facebook", label: "Facebook" }, { k: "linkedin", label: "LinkedIn" },
  { k: "youtube", label: "YouTube" }, { k: "tiktok", label: "TikTok" }, { k: "sin_presencia", label: "Aún no tengo presencia" },
];

// Texto libre "a, b, Otro texto" <-> { chips, other }
export const splitChips = (str, options) => {
  const parts = (str || "").split(",").map((s) => s.trim()).filter(Boolean);
  return { chips: parts.filter((p) => options.includes(p)), other: parts.filter((p) => !options.includes(p)).join(", ") };
};
export const joinChips = (chips, other) => [...chips, ...(other.trim() ? [other.trim()] : [])].join(", ");


// «Cliente / público ideal» derivado de lo ya contestado en el onboarding (mismo criterio que el backend).
const AUDIENCE_KEYS = ["who_help", "buyer_audience", "student_profile", "partner_profile", "who_find", "client_type", "sectors", "niche", "establishment_type"];
const AUDIENCE_LABELS = { cliente_final: "Cliente final", empresa: "Empresas", ambos: "Cliente final y empresas" };
export const deriveIdealClient = (biz) => {
  const q = (biz && biz.questionnaire) || {};
  const parts = AUDIENCE_KEYS.map((k) => String(q[k] || "").trim()).filter(Boolean).map((v) => AUDIENCE_LABELS[v] || v);
  return [...new Set(parts)].join("; ").slice(0, 400);
};

// v19 · Negocio local que busca clientes: en Instagram casi nadie pone su barrio en la bio, así que se le recomienda
// buscar recomendadores de su zona (negocios y profesionales complementarios que le pueden mandar clientes).
const CLIENT_GOALS = ["clientes_producto", "clientes_servicio"];
export const needsLocalClientNote = (biz) =>
  (biz?.business_type === "local") && (biz?.goals_list || []).some((g) => CLIENT_GOALS.includes(g));
export const LOCAL_CLIENT_NOTE =
  "Un aviso sincero: en Instagram casi nadie pone su barrio o su ciudad en la bio, así que encontrar clientes " +
  "vecinos uno a uno funciona poco. Lo que sí funciona en un negocio local es encontrar negocios y profesionales de tu " +
  "zona que te pueden mandar clientes: a una peluquería, fotógrafos de bodas o tiendas de novia; a un gimnasio, " +
  "fisioterapeutas o nutricionistas.";
export const LOCAL_RECOMMENDER_GOAL = "promotores";
